import { getResellerForm } from "../../../services/forms.services";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IForms } from "../../../types/forms";
import ReactPagination from "../../Common/ReactPagination";
import Loading from "../../Common/LoadingScreen";
import Moment from "moment";
import deleteDataByID from "../../../services/delete.services";

import Modal from "react-modal";
import { jwtDecode } from "jwt-decode";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/animations/scale.css";
import downloadAsFiles from "../../../services/download.services";
import deleteByID from "../../../services/lenderDelete.service";

export const ResellerList = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const [contacts, setContacts] = useState<any>();
  const [limit, setLimit] = useState<number>(10);
  const [offset, setOffSet] = useState<number>(0);
  const [search, setSearch] = useState<string>("");
  const [buttonDisable, setButtonDisable] = useState<boolean>(false);

  const [selectedData, setSelectedData] = useState<any>([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState<boolean>(false);

  const [deleteDataByIDModal, setDeleteDataByIDModal] = useState(false);
  const [dataID, setDataID] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const handleModal = () => setDeleteDataByIDModal(!deleteDataByIDModal);

  const deleteValue = (id: any, firstName: any, lastName: any) => {
    setFirstName(firstName);
    setLastName(lastName);
    setDataID(id);
  };

  useEffect(() => {
    getContacts();
  }, [offset, limit, search]);

  const tokenInfo: any = jwtDecode(
    localStorage.getItem("access_token") as string,
  );

  const handleDownload = async () => {
    setButtonDisable(true);
    const fileData = await downloadAsFiles("formType=reseller-application-form");
    // const blob = new Blob([fileData.data], { type: 'text/csv;charset=utf-8;' });

    const selectedFileData = await downloadAsFiles(
      `formType=reseller-application-form${selectedData
        .map((item: any) => `&selectedId=${item.id}`)
        .join("")}`,
    );

    let blob: any;
    if (selectedData) {
      blob = new Blob([selectedFileData.data], {
        type: "text/csv;charset=utf-8;",
      });
    } else {
      blob = new Blob([fileData.data], { type: "text/csv;charset=utf-8;" });
    }

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "contacts.csv");
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    setButtonDisable(false);

    getContacts();
  };

  const getContacts = async () => {
    const getFormsArgs = {
      formType: "reseller-application-form",
      limit: limit,
      offset: offset,
      name: search,
    };
    try {
      const allcontact = await getResellerForm(getFormsArgs);
      setContacts(allcontact.data);
      setIsLoading(false);
    } catch (e: any) {
      if (!e.statusCode) {
        localStorage.removeItem("access_token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    const includes = contacts?.data.every((contact: any) => {
      return selectedData?.some((selected: any) => selected.id === contact.id);
    });
    // console.log('includes: ', includes);
    includes ? setIsSelectAllChecked(true) : setIsSelectAllChecked(false);
  }, [contacts?.data]);

  const handleInput = (event: any) => {
    setSearch(event.target.value);
  };

  const handleDelete = async (id: any) => {
    try {
      await deleteByID("reseller", id);
      handleModal();
      getContacts();
    } catch (e: any) {
      if (!e.statusCode) {
        localStorage.removeItem("access_token");
        navigate("/");
      }
    }
  };

  const handleChange = (e: any) => {
    const { id, checked } = e.target;
    // console.log('id: ', id);
    // console.log('checked: ', checked);
    let filteredCheckedData: any = [];
    let allCheckedData: any = [];

    if (id === "selectAll") {
      // console.log('Entered into selectedAll zone..');

      if (
        checked &&
        !contacts?.data.every((contact: any) => {
          return selectedData?.some(
            (selected: any) => selected.id === contact.id,
          );
        })
      ) {
        allCheckedData = [
          ...selectedData,
          ...contacts?.data.map((contact: any) => ({
            ...contact,
            // checked: true,
          })),
        ];
      } else if (
        !checked &&
        contacts?.data.every((contact: any) => {
          return selectedData?.some(
            (selected: any) => selected.id === contact.id,
          );
        })
      ) {
        allCheckedData = selectedData?.filter(
          (data: any) =>
            !contacts?.data.some(
              (contact: any) =>
                contact.id === data.id && contact.name === data.name,
            ),
        );
      }

      if (allCheckedData.length > 0) {
        filteredCheckedData = allCheckedData?.filter(
          (dataItem: any, index: any, self: any) =>
            index ===
            self.findIndex(
              (i: any) => i.id === dataItem.id && i.name === dataItem.name,
            ),
        );
        setSelectedData(filteredCheckedData);
      } else {
        setSelectedData(allCheckedData);
      }
      setIsSelectAllChecked(checked);
    } else {
      // console.log('Entered into plane zone..');
      // checked ? console.log('yes') : console.log('nope');

      const updatedSelectedData = checked
        ? [
            ...selectedData,
            contacts?.data.find((contact: any) => contact.id === Number(id)),
          ]
        : selectedData?.filter((contact: any) => contact.id !== Number(id));

      // console.log('Updated Selected Data', updatedSelectedData);

      setSelectedData(updatedSelectedData);

      contacts?.data.every((contact: any) => {
        return updatedSelectedData?.some(
          (element: any) => element.id === contact.id,
        );
      })
        ? setIsSelectAllChecked(true)
        : setIsSelectAllChecked(false);
    }
  };

  return (
    <>
      {/* <section className="main-container">
        <div className="top-section align-items-center row">
          <div className="col-md-9">
            <div className="xlarge-text-size">Contact</div>
          </div>
          <div className="col-md-3 col-xl-2 text-right">
            <input
              value={search}
              onChange={handleInput}
              placeholder="Search by name"
            />
          </div>
          <div className="col-md-2 text-right">
            <button
              type="button"
              className="btn"
              onClick={handleDownload}
              disabled={buttonDisable}
            >
              Download{" "}
              {selectedData?.length === 0 ? "all" : selectedData?.length}
            </button>
          </div>
        </div> */}

      <section className="main-container">
        <div className="top-section align-items-center row justify-content-between px-3">
          <div className="xlarge-text-size">Reseller</div>
          <div className="d-flex col-md-8 justify-content-end px-0">
            <input
              value={search}
              onChange={handleInput}
              placeholder="Search by name"
              className="col-md-6 col-lg-4 col-xl-3"
            />
            {tokenInfo.permissions?.includes("Download") && (
              <button
                type="button"
                className="btn ml-3"
                onClick={handleDownload}
                disabled={buttonDisable}
              >
                Download{" "}
                {selectedData?.length === 0 ? "all" : selectedData?.length}
              </button>
            )}
          </div>
        </div>

        {/* main data */}
        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              {isLoading && <Loading />}
              <table className="table">
                <thead>
                  <tr key="title">
                    <th className="xs">
                      <input
                        type="checkbox"
                        id="selectAll"
                        onChange={handleChange}
                        checked={isSelectAllChecked}
                      />
                    </th>
                    <th className="xs">S.No.</th>
                    <th>Full Name</th>
                    <th>Email</th>
                    <th>Email Status</th>
                    <th>Country</th>
                    <th>phoneNumber</th>
                    <th>jobTitle</th>
                    <th>legalBusinessName</th>
                    <th>businessWebsite</th>
                    <th>numOfEmployees</th>
                    <th>primaryDBA</th>
                    <th>businessType</th>
                    <th>annualRevenue</th>
                    <th>customerServed</th>
                    <th>address1</th>
                    <th>address2</th>
                    <th>addressCountry</th>
                    <th>addressCity</th>
                    <th>addressState</th>
                    <th>addressZip</th>
                    <th>companyContactPerson</th>
                    <th>companyContactNumber</th>

                    <th className="sm">Source</th>
                    <th className="sm">Medium</th>
                    <th className="sm">Campaign</th>
                    <th className="sm">Content</th>
                    <th>Submitted on</th>
                    {tokenInfo.permissions?.includes("Delete") ? (
                      <th className="xs">Action</th>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {contacts?.data === ""
                    ? "Empty data"
                    : contacts?.data.map((contact: IForms, index: any) => {
                        return (
                          <tr key={contact.id}>
                            <td>
                              <input
                                type="checkbox"
                                id={JSON.stringify(contact.id)}
                                checked={selectedData?.some(
                                  (item: any) => item.id === contact.id,
                                )}
                                onChange={handleChange}
                              />
                            </td>
                            <td>
                              <span>{index + offset + 1}</span>
                            </td>
                            <td>
                              {contact.firstName !== "." ? (
                                <>
                                  <span>{contact.firstName}</span>{" "}
                                  <span>{contact.lastName}</span>
                                </>
                              ) : (
                                <span>{contact.fullName}</span>
                              )}
                            </td>
                            <td>
                              <span>{contact.verifyEmail}</span>
                            </td>
                            <td>
                              <span
                                className={`badge ${
                                  contact?.emailVerificationStatus?.toLowerCase() ??
                                  ""
                                }`}
                              >
                                {contact?.emailVerificationStatus?.toLowerCase() ??
                                  "-"}
                              </span>
                            </td>
                            <td>
                              <span>{contact.country}</span>
                            </td>
                            <td>
                              <span>{contact.phoneNumber}</span>
                            </td>
                            <td>
                              <span>{contact.jobTitle}</span>
                            </td>
                            <td>
                              <span>{contact.legalBusinessName}</span>
                            </td>
                            <td>
                              <span>{contact.businessWebsite}</span>
                            </td>
                            <td>
                              <span>{contact.numOfEmployees}</span>
                            </td>
                            <td>
                              <span>{contact.primaryDBA}</span>
                            </td>

                            <td>
                              <span>{contact.businessType}</span>
                            </td>
                            <td>
                              <span>{contact.annualRevenue}</span>
                            </td>
                            <td>
                              <span>{contact.customerServed}</span>
                            </td>
                            <td>
                              <span>{contact.address1}</span>
                            </td>
                            <td>
                              <span>{contact.address2}</span>
                            </td>
                            <td>
                              <span>{contact.addressCountry}</span>
                            </td>
                            <td>
                              <span>{contact.addressCity}</span>
                            </td>
                            <td>
                              <span>{contact.addressState}</span>
                            </td>
                            <td>
                              <span>{contact.addressZip}</span>
                            </td>
                            <td>
                              <span>{contact.companyContactPerson}</span>
                            </td>
                            <td>
                              <span>{contact.companyContactNumber}</span>
                            </td>
                            <td className="hide">
                              <span>{contact.pageName}</span>
                            </td>
                            <td className="lg hide">
                              {contact?.pageUrl?.length > 100 ? (
                                <>
                                  <span>
                                    {contact?.pageUrl.substring(0, 100)}...
                                  </span>
                                  <Tippy
                                    animation="scale"
                                    theme="light-border"
                                    interactive={true}
                                    content={contact.pageUrl}
                                    trigger="click"
                                  >
                                    <span className="see-more">see more</span>
                                  </Tippy>
                                </>
                              ) : (
                                <span>{contact.pageUrl}</span>
                              )}
                            </td>
                            <td className="hide">
                              <span>{contact.buttonId}</span>
                            </td>
                            <td className="sm">
                              <span>{contact.utmSource}</span>
                            </td>
                            <td className="sm">
                              <span>{contact.utmMedium}</span>
                            </td>
                            <td className="sm">
                              <span>{contact.utmCampaign}</span>
                            </td>
                            <td className="sm">
                              <span>{contact.utmContent}</span>
                            </td>

                            <td>
                              <span className="">
                                {Moment(contact.createdAt).format(
                                  "ddd, MMM Do YYYY, h:mm:ss a",
                                )}
                              </span>
                              <span className="hide">{contact.createdBy}</span>
                            </td>
                            <td className="hide">
                              <span>{contact.isActive}</span>
                            </td>
                            <td className="hide">
                              <span>{contact.isArchived}</span>
                            </td>
                            <td className="hide">
                              <span>{contact.updatedAt}</span>
                            </td>
                            <td className="hide">
                              <span>{contact.updatedBy}</span>
                            </td>
                            <td className="hide">
                              <span>{contact.internalComment}</span>
                            </td>
                            {tokenInfo.permissions?.includes("Delete") ? (
                              <>
                                <td className="xs">
                                  <button
                                    className="btn-danger btn"
                                    type="button"
                                    onClick={() => {
                                      handleModal();
                                      deleteValue(
                                        contact.id,
                                        contact.lastName,
                                        contact.firstName,
                                      );
                                    }}
                                  >
                                    Delete
                                  </button>
                                </td>{" "}
                              </>
                            ) : (
                              ""
                            )}
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>
            <div className="pagination-log">
              <ReactPagination
                totalData={contacts}
                setLimit={setLimit}
                setOffSet={setOffSet}
                limit={limit}
              />
            </div>
          </div>
        </div>
      </section>

      <Modal
        isOpen={deleteDataByIDModal}
        onRequestClose={handleModal}
        contentLabel="delete-data"
      >
        <div className="head">
          <h4>Remove data</h4>
        </div>
        <div className="m-body">
          <div>
            Are you sure you want to remove this{" "}
            <b>
              {firstName} {lastName}
            </b>{" "}
            data
          </div>
        </div>
        <div className="m-footer">
          <button className="btn btn-link" onClick={handleModal}>
            Close
          </button>{" "}
          {"  "}
          <button
            className="btn btn-danger"
            onClick={() => handleDelete(dataID)}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};
